@use '../../../../../../styles/Colors.scss' as Colors;
@use '../../../../../../styles/Constants.scss' as Constants;

.modal {
	&__container {
		display: flex;
		flex-direction: column;
		gap: Constants.$val-spacing-l;
		padding: Constants.$val-spacing-m Constants.$val-spacing-s;
	}

	&__col {
		padding-left: 0px;
	}

	&__approved-warning {
		padding: Constants.$val-spacing-m Constants.$val-spacing-s;
		background-color: Colors.$col-canceledRed;
		color: Colors.$col-white;
		text-align: center;
	}

	&__search-container {
		position: relative;
		display: flex;
		flex-flow: row nowrap;
		align-items: center;
		position: sticky;
		top: 0;
		z-index: 5;

		&__search-input {
			width: 100%;
		}

		&__search-icon {
			right: Constants.$val-spacing-l; // Both outside border and input offset taken into account
			position: absolute;
			font-size: Constants.$val-fontSizeBig;
			color: Colors.$col-greyFontLight;
		}
	}

	&__legend {
		display: flex;
		padding: Constants.$val-spacing-m Constants.$val-spacing-s;

		&__single {
			display: flex;
			align-items: center;
			margin-right: Constants.$val-spacing-m;

			&__empty-cell {
				display: inline-block;
				height: Constants.$val-spacing-m;
				width: Constants.$val-spacing-m;
				border: 1px solid Colors.$col-greyMid;
				margin-right: Constants.$val-spacing-s;
				border-radius: Constants.$val-borderRadius;

				&--selected {
					background-color: Colors.$col-design-red4;
				}

			}

		}
	}
}

.job-report-list {

	&__container {
		display: flex;
		flex-direction: column;
		gap: Constants.$val-spacing-m;
	}

	&__list-container {
		gap: Constants.$val-spacing-xxs;
	}
	
	&__selected {
		color: Colors.$col-greyInactive;
		font-style: italic;
	}

	&__action-container {
		display: flex;
		flex-direction: row;
	}
}

.job-report-item {
	&__container {
		display: flex;
		flex-direction: row;
		gap: Constants.$val-spacing-m;

		&--not-approved {
			background-color: Colors.$col-design-red4;
		}
	}

	&__checkbox {
		background-color: Colors.$col-white;
	}

	&__code {
		text-transform: uppercase;
		font-weight: bold;
	}

	&__info-container {
		display: flex;
		flex-direction: row;
		gap: Constants.$val-spacing-s;
		font-size: Constants.$val-fontSizeSmall;
	}
}